import "../../../index74.css";
import { jsx as k } from "react/jsx-runtime";
import { useRef as C, useEffect as R, useCallback as g } from "react";
import { _ } from "../../../cs-Dfox81s-.js";
import "../../../type-Dku6Xzl6.js";
import h from "../../RawButton/index.js";
const O = "_generic-option_16gez_1", b = {
  genericOption: O
};
function j(c) {
  const {
    optionContainerClassName: i,
    contentRenderer: s,
    contentRendererParam: a,
    option: o,
    onClick: r,
    optionKey: e,
    focusedKey: n
  } = c, l = a(e, o), {
    containerClassName: m,
    title: p,
    ...f
  } = l, u = (n == null ? void 0 : n.key) === e, t = C(null);
  R(
    () => {
      n && n.key === e && !n.mouse && t.current && t.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    [e, n]
  );
  const d = g(
    () => {
      r(e, o);
    },
    [e, o, r]
  );
  return /* @__PURE__ */ k(
    h,
    {
      elementRef: t,
      className: _(
        b.genericOption,
        i,
        m
      ),
      onClick: d,
      title: p,
      name: e,
      focused: u,
      children: s(f)
    }
  );
}
export {
  j as default
};
